import { RouteRecordRaw } from 'vue-router';
import SeekerFavorites from '@/apps/account/seeker/favorites/SeekerFavorites.vue';
import { requireSeeker } from '@/router/guards/authGuards';

const favoritesRoutes: RouteRecordRaw[] = [
  {
    path: '/account/seeker/favorites/:careType(babysitter|nanny|pet_care|companion_care|special_needs|housekeeping)',
    redirect: (to) => ({ path: '/account/seeker/favorites', query: { ...to.query, careType: to.params.careType } }),
  },
  {
    path: '/account/seeker/favorites',
    name: 'seeker-favorites',
    component: SeekerFavorites,
    beforeEnter: requireSeeker,
  },
];

export default favoritesRoutes;
